export const DAY = "day";
export const EVENING = "evening";
